import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardText,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";

const EmptyState = () => (
  <Card>
    <div className="text-center p-5">
      <div className="mb-4">
        <i className="mdi mdi-file-search text-primary" style={{ fontSize: "4rem" }} />
      </div>
      <h3 className="mb-3 font-weight-bold">No Recommendations Available Yet</h3>
      <p className="text-muted mb-4">
        It looks like there are no recommendations available at the moment. This could be due to recent activity or pending data updates. 
        To gain recommendations and enhance your security.
      </p>
      
      <div className="d-flex justify-content-center gap-3">
        <Link to="/vulnerabilityscan" className="btn btn-primary px-4 py-2">
          Start a Vulnerability Scan
        </Link>
        <Link to="/malwareAnalysis" className="btn btn-warning px-4 py-2">
          Run Malware Analysis
        </Link>
        <Link to="/tm-create" className="btn btn-success px-4 py-2">
          Begin AI Threat Modeling
        </Link>
      </div>
    </div>
  </Card>
);

const selectSevirityColor = (severity) => {
  switch (severity) {
    case "W":
    case "M":
      return "warning";
    case "I":
    case "L":
      return "info";
    case "D":
    case "C":
      return "danger";
    case "H":
    case "O":
      return "orange";
  }}
      

const RecommendationCard = ({ recommendation, onClick }) => (
  <Card
    outline
    color={selectSevirityColor(recommendation.severityLetter)}
    className="border h-100" // Added h-100 for full height
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <CardHeader className="bg-transparent">
      <h5 className={`my-0 text-${selectSevirityColor(recommendation.severityLetter)}`}>
        <i className={`${recommendation.icon} me-3`} />
        {recommendation.title}
      </h5>
    </CardHeader>
    <CardBody className="d-flex flex-column">
      <CardText className="flex-grow-1" style={{ 
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: "4",
        WebkitBoxOrient: "vertical",
        textOverflow: "ellipsis"
      }}>
        {recommendation.content}
      </CardText>
    </CardBody>
  </Card>
);

const Recommendations = () => {
  const [recommendations, setRecommendations] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const userId = obj.username;

  const toggle = () => setModal(!modal);

  

  useEffect(() => {
    fetch(`https://api.bluhawk.live/recommendations/${userId}`)
      .then((response) => response.json())
      .then((data) => setRecommendations(data))
      .catch((error) => console.error("Error fetching recommendations:", error));
  }, [userId]);

  const handleCardClick = (recommendation) => {
    setSelectedRecommendation(recommendation);
    toggle();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs breadcrumbItem="Recommendations" />
        <Row className="g-4"> {/* Added consistent gap between cards */}
          {recommendations.length > 0 ? (
            recommendations.map((recommendation, index) => (
              <Col lg={4} md={6} sm={12} key={index}>
                <RecommendationCard
                  recommendation={recommendation}
                  onClick={() => handleCardClick(recommendation)}
                />
              </Col>
            ))
          ) : (
            <EmptyState />
          )}
        </Row>

        <Modal isOpen={modal} toggle={toggle} centered size="lg">
          <ModalHeader toggle={toggle}>
            {selectedRecommendation && (
              <h3 className={`text-${selectSevirityColor(selectedRecommendation.severityLetter)}`}>
                {selectedRecommendation.title}
              </h3>
            )}
          </ModalHeader>
          <ModalBody>
            {selectedRecommendation ? (
              <div>
                <h5 className="mb-3">{selectedRecommendation.content}</h5>
                <p>{selectedRecommendation.detailedDescription}</p>
              </div>
            ) : (
              <p>No details available.</p>
            )}
            <div className="text-end">
              <Button color="primary" onClick={toggle}>
                Close
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Recommendations;